/** Shared with `CreateDestinationModal`; `MAPPING` now lives inside `SourceCreation`. */
export const Step = Object.freeze({
    /** Pick the type from the catalog. */
    CATALOG: "CATALOG",
    /** Configure the picked type. */
    INFO: "INFO",
    /** Attach the created item to a tracker. */
    TRACKER: "TRACKER",
});
